export default [
  // {
  //   id: "el1-2",
  //   source: "1",
  //   target: "2",
  //   type: "buttonedge",
  // },
  // { id: "el2-3", source: "2", target: "3", animated: false },
  // { id: "el2-4", source: "2", target: "4", animated: true },
  // { id: "el2-5", source: "2", target: "5", animated: false },
  // { id: "el5-6", source: "5", target: "6", type: "buttonedge" },
];
